/** The vendor for this key expects it to be exposed in js bundles and only asks we don't advertise our key **/
const xgrid_key =
  "a1267c8bb0d94b739a17f95f161b64a1Tz0xMTM4OTcsRT0xNzgwMjcxOTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=";
export { xgrid_key };
